import { L } from '@lang';
import { QrCode } from '@dui/QrCode';
import { ReactComponent as Icon } from '../../shared/assets/logo.svg';
import { imageGetters } from '../../helpers/imageGetters';
import { Placeholder } from '../../shared/ui';
import styles from './PwaInstallDesktop.module.css';

export function PwaInstallDesktop() {
  const background = `url(${imageGetters.background()}) no-repeat center / 100% 100%`;

  return (
    <div className={styles.root} style={{ background }}>
      <Placeholder
        title={<span className={styles.title}>{L.t('web_install_pwa_title')}</span>}
        icon={<QrCode Icon={Icon} errorText={L.t('fetch_failed')} url={window.location.href} />}
      >
        <span className={styles.subtitle}>{L.t('web_install_pwa_subtitle')}</span>
      </Placeholder>
    </div>
  );
}
